import { render } from "./idCardUploadWay.vue?vue&type=template&id=13f18230"
import script from "./idCardUploadWay.vue?vue&type=script&lang=js"
export * from "./idCardUploadWay.vue?vue&type=script&lang=js"

import "./idCardUploadWay.vue?vue&type=style&index=0&id=13f18230&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__